// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"101":"28bc5695","133":"9d96d494","141":"07c818a4","279":"85c329e0","510":"0cf8d2dd","664":"8612839e","984":"92d06c8d","987":"fb71d781"}[chunkId] + ".js";
};